import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SponsorInfoContent from "./SponsorInfoContent";
import CollapseContent from "./CollapseContent";
import { isRoleSponsor } from "../orphans/utils";
import { SwitchAccountSelect } from "./SwitchAccountSelect";
import {
  getSponsorDetails,
  getSponsoredOrphans,
} from "../../../../apis/actions/sponsor.actions";
import { AppDispatch, RootState } from "../../../../apis/store";
interface ContentProfileProps {
  data: any;
  role: string;
}
export const SponsorProfile = ({ data, role }: ContentProfileProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const { sponsoredOrphans } = useSelector((state: RootState) => state.sponsor);
  const [dataFetched, setDataFetched] = useState(false);
  const hasRelatedAccounts =
    dataFetched && data?.related_accounts && data.related_accounts.length > 0;
  const OtpId = useSelector((state: RootState) => state?.recipient?.OtpId);
  const benificiaryTabs = useMemo(() => {
    const mainOrphans = sponsoredOrphans?.filter(
      (orph: any) =>
        orph.sponsorship_type === "main" ||
        orph.sponsorship_type === "main_support"
    );
    const supportOrphans = sponsoredOrphans?.filter(
      (orph: any) =>
        orph.sponsorship_type === "support" ||
        orph.sponsorship_type === "main_support"
    );
    const widowOrphans = sponsoredOrphans?.filter(
      (orph: any) => orph.sponsorship_type === "widow"
    );

    return [
      { label: "كفالة رئيسية", array: mainOrphans },
      { label: "كفالة دعم", array: supportOrphans },
      { label: "كفالة أرملة", array: widowOrphans },
    ].filter((tab) => tab.array?.length > 0);
  }, [sponsoredOrphans]);
  useEffect(() => {
    setDataFetched(false);
    Promise.all([
      dispatch(getSponsoredOrphans({ sponsor_id: OtpId })),
      dispatch(getSponsorDetails({ sponsor_id: OtpId })),
    ]).then(() => setDataFetched(true));
  }, [dispatch, OtpId]);
  return (
    <div className="takaful--content-profile">
      <div className="takaful--content-edit-profile-info">
        <div className="takaful--content-profile-title">
          <h1 style={{ marginBottom: "4rem" }}> المعلومات الأساسية </h1>
          {role !== "school" && hasRelatedAccounts && (
            <div>
              <SwitchAccountSelect
                relatedAccounts={data?.related_accounts}
                accountsNumber={data?.accounts_number}
              />
            </div>
          )}
        </div>
        <SponsorInfoContent infoArray={data} role={role} />
      </div>
      {isRoleSponsor(role) && (
        <div className="takaful--content-profile-info">
          <CollapseContent data={sponsoredOrphans} tabsData={benificiaryTabs} />
        </div>
      )}
    </div>
  );
};
